(() => {
  const initQuiz = (root) => {
    if (!root || root.dataset.quizReady === 'true') return;
    root.dataset.quizReady = 'true';

    const dialog = root.querySelector('dialog');
    if (!dialog) return;

    const panels = [...root.querySelectorAll('[data-quiz-panel]')];
    const visuals = [...root.querySelectorAll('[data-quiz-visual]')];
    const progress = root.querySelector('[data-quiz-progress]');
    const progressLabel = root.querySelector('[data-quiz-progress-label]');
    const nav = root.querySelector('[data-quiz-nav]');
    const stepCount = root.querySelector('[data-quiz-step-count]');
    const tagInput = root.querySelector('[data-quiz-tags]');
    const tip = root.querySelector('[data-quiz-tip]');
    const profileTitle = root.querySelector('[data-quiz-profile-title]');
    const answers = {};
    const storageKey = 'ot3-sleep-quiz-v1';
    const resultStorageKey = 'ot3-sleep-quiz-result-v2';
    const signupSourceStorageKey = 'ot3-signup-source-v1';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const progressLabels = ['Introduktion', 'Din temperatur', 'Din seng', 'Dit fokus', 'Din anbefaling'];
    let current = 0;
    let opened = false;
    let autoOpenDisabled = false;

    const setStorage = (status, days) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ status, until: Date.now() + days * 86400000 }));
      } catch (error) {
        // The quiz still works when storage is unavailable.
      }
    };

    const isCoolingDown = () => {
      try {
        const value = JSON.parse(localStorage.getItem(storageKey) || 'null');
        return Boolean(value && value.until > Date.now());
      } catch (error) {
        return false;
      }
    };

    const setSignupSource = (source) => {
      try {
        sessionStorage.setItem(signupSourceStorageKey, source);
      } catch (error) {
        return;
      }
    };

    const getSignupSource = () => {
      try {
        return sessionStorage.getItem(signupSourceStorageKey) || '';
      } catch (error) {
        return '';
      }
    };

    const clearSignupSource = () => {
      try {
        sessionStorage.removeItem(signupSourceStorageKey);
      } catch (error) {
        return;
      }
    };

    const setVisual = (name) => {
      visuals.forEach((visual) => visual.classList.toggle('is-active', visual.dataset.quizVisual === name));
    };

    const showPanel = (index) => {
      current = Math.max(0, Math.min(index, panels.length - 1));
      panels.forEach((panel) => {
        const active = Number(panel.dataset.quizPanel) === current;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      const widths = ['8%', '33%', '66%', '100%', '100%'];
      if (progress) progress.style.width = widths[current] || '100%';
      if (progressLabel) progressLabel.textContent = progressLabels[current] || progressLabels[4];
      if (nav) nav.hidden = current === 0 || current === 4;
      if (stepCount && current > 0 && current < 4) stepCount.textContent = `${current} / 3`;
      if (current === 0) setVisual('intro');
      if (current === 1) setVisual('thermal');
      if (current === 2 || current === 3) setVisual('setup');
      window.requestAnimationFrame(() => {
        panels.find((panel) => Number(panel.dataset.quizPanel) === current)?.querySelector('h2')?.focus({ preventScroll: true });
      });
    };

    const open = (force = false) => {
      if (opened || dialog.open) return;
      if (!force && (autoOpenDisabled || root.dataset.enabled !== 'true' || isCoolingDown())) return;
      opened = true;
      dialog.showModal();
      document.documentElement.classList.add('ot3-quiz-open');
      showPanel(current);
    };

    const close = (completed = false) => {
      if (dialog.open) dialog.close();
      opened = false;
      document.documentElement.classList.remove('ot3-quiz-open');
      setStorage(completed ? 'completed' : 'dismissed', completed ? 60 : Number(root.dataset.cooldown || 7));
    };

    const buildResult = () => {
      const recommendation = answers.setup === 'alone' ? 'single' : 'dual';
      root.querySelectorAll('[data-quiz-result]').forEach((result) => {
        result.hidden = result.dataset.quizResult !== recommendation;
      });
      setVisual(recommendation);
      const profileTitles = {
        hot: 'Mindre varme omkring kroppen',
        cold: 'En rolig og lun overgang til natten',
        changing: 'Et mere stabilt sovemiljø',
        restless: 'En fast rytme med mindre aktivering'
      };
      const tips = {
        hot: 'Brug en lettere dyne eller mere åndbart sengetøj i syv nætter. Notér kun, om du vågner varm eller svedig, så du kan se et mønster uden at ændre flere ting samtidig.',
        cold: 'Skab en rolig nedtrapning og varm fødderne før sengetid med sokker eller et kort, varmt bad. Vurder efter syv nætter, om kulden stadig vækker dig.',
        changing: 'Notér tidspunktet for opvågninger, dyne, nattøj og rummets følelse i syv nætter. Det afslører ofte, hvornår soveklimaet skifter.',
        restless: 'Hold opvågningstidspunktet stabilt i syv dage og vælg 30 rolige minutter før sengetid. Vurder din energi midt på dagen frem for at bedømme natten med det samme.'
      };
      const additions = {
        routine: ' Gør den samme enkle aftenrutine hver dag.',
        room: ' Dæmp lys og støj, og luft soveværelset ud inden sengetid.',
        temperature: ' Hold dyne og nattøj ens, mens du observerer.'
      };
      if (profileTitle) profileTitle.textContent = profileTitles[answers.thermal] || profileTitles.restless;
      if (tip) tip.textContent = `${tips[answers.thermal] || tips.restless}${additions[answers.focus] || ''}`;
      if (tagInput) {
        tagInput.value = ['newsletter', 'sleep-guide', 'sleep-quiz', `recommendation-${recommendation}`, `thermal-${answers.thermal || 'unknown'}`, `focus-${answers.focus || 'unknown'}`].join(',');
      }
      try {
        localStorage.setItem(resultStorageKey, JSON.stringify({ recommendation, thermal: answers.thermal, focus: answers.focus }));
      } catch (error) {
        return showPanel(4);
      }
      showPanel(4);
    };

    const restoreResult = () => {
      try {
        const saved = JSON.parse(localStorage.getItem(resultStorageKey) || 'null');
        if (!saved) return;
        answers.setup = saved.recommendation === 'single' ? 'alone' : 'same';
        answers.thermal = saved.thermal || 'restless';
        answers.focus = saved.focus || 'routine';
        buildResult();
      } catch (error) {
        showPanel(4);
      }
    };

    const footerForm = document.getElementById('ContactFooter');
    const handleFooterSubmit = (event) => {
      if (!footerForm || footerForm.dataset.submitting === 'true') return;

      autoOpenDisabled = true;
      setSignupSource('footer');
      footerForm.dataset.submitting = 'true';
      footerForm.setAttribute('aria-busy', 'true');

      try {
        const frame = document.createElement('iframe');
        frame.name = `ot3-newsletter-${Date.now()}`;
        frame.hidden = true;
        frame.tabIndex = -1;
        frame.setAttribute('aria-hidden', 'true');
        document.body.appendChild(frame);
        footerForm.target = frame.name;

        const successTemplate = footerForm.querySelector('#ContactFooter-success-template');
        const visibleSuccess = successTemplate?.content.firstElementChild?.cloneNode(true);
        if (!visibleSuccess) throw new Error('Missing newsletter success template');

        footerForm.querySelector('#ContactFooter-success')?.remove();
        const fieldWrapper = footerForm.querySelector('.newsletter-form__field-wrapper');
        if (fieldWrapper) fieldWrapper.hidden = true;
        footerForm.appendChild(visibleSuccess);
        footerForm.removeAttribute('aria-busy');
        footerForm.dataset.submitting = 'false';
        setStorage('footer-subscribed', 3650);
        clearSignupSource();
        visibleSuccess.focus({ preventScroll: true });
        window.setTimeout(() => frame.remove(), 30000);
      } catch (error) {
        event.preventDefault();
        let errorMessage = footerForm.querySelector('#ContactFooter-error');
        if (!errorMessage) {
          errorMessage = document.createElement('small');
          errorMessage.id = 'ContactFooter-error';
          errorMessage.className = 'newsletter-form__message form__message';
          errorMessage.textContent = 'Der opstod en fejl. Prøv igen om et øjeblik.';
          footerForm.querySelector('.newsletter-form__field-wrapper')?.appendChild(errorMessage);
        }
        const emailInput = footerForm.querySelector('input[type="email"]');
        emailInput?.setAttribute('aria-invalid', 'true');
        emailInput?.setAttribute('aria-describedby', 'ContactFooter-error');
        emailInput?.focus({ preventScroll: true });
      } finally {
        if (footerForm.dataset.submitting === 'true') {
          footerForm.dataset.submitting = 'false';
          footerForm.removeAttribute('aria-busy');
        }
      }
    };

    root.querySelector('[data-quiz-start]')?.addEventListener('click', () => showPanel(1));
    root.querySelector('[data-quiz-back]')?.addEventListener('click', () => showPanel(Math.max(0, current - 1)));
    root.querySelectorAll('[data-quiz-close]').forEach((button) => button.addEventListener('click', () => close(false)));
    root.querySelectorAll('[data-quiz-option]').forEach((option) => {
      option.addEventListener('click', () => {
        const question = option.dataset.question;
        answers[question] = option.dataset.value;
        root.querySelectorAll(`[data-question="${question}"]`).forEach((item) => {
          item.classList.toggle('is-selected', item === option);
          item.setAttribute('aria-pressed', String(item === option));
        });
        window.setTimeout(() => current < 3 ? showPanel(current + 1) : buildResult(), reduceMotion ? 0 : 160);
      });
    });

    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(false); });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(false); });
    document.querySelectorAll('[data-ot3-open-sleep-quiz]').forEach((button) => button.addEventListener('click', () => open(true)));
    footerForm?.addEventListener('submit', handleFooterSubmit, { capture: true });
    root.querySelector('#Ot3SleepGuideForm')?.addEventListener('submit', () => setSignupSource('quiz'));

    const params = new URLSearchParams(window.location.search);
    const returnHash = window.location.hash;
    const signupSource = getSignupSource() || (returnHash === '#ContactFooter' ? 'footer' : returnHash === '#Ot3SleepGuideForm' ? 'quiz' : '');
    const footerSuccess = document.getElementById('ContactFooter-success');
    const footerError = document.getElementById('ContactFooter-error');
    if (signupSource === 'footer' && footerSuccess) {
      setStorage('footer-subscribed', 3650);
      clearSignupSource();
      return;
    }
    if (signupSource === 'footer' && footerError) {
      clearSignupSource();
      return;
    }
    if (root.querySelector('[data-quiz-success]')) {
      current = 4;
      setStorage('completed', 60);
      clearSignupSource();
      open(true);
      restoreResult();
      return;
    }
    if (root.querySelector('.ot3-sleep-quiz__error') || params.get('sleep-quiz') === 'open') {
      current = root.querySelector('.ot3-sleep-quiz__error') ? 4 : 0;
      open(true);
      return;
    }
    if (window.Shopify?.designMode || root.dataset.enabled !== 'true' || isCoolingDown()) return;

    const triggerPercent = Number(root.dataset.scrollTrigger || 45) / 100;
    const onScroll = () => {
      const available = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      if (window.scrollY / available < triggerPercent) return;
      window.removeEventListener('scroll', onScroll);
      open(false);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(() => open(false), Number(root.dataset.delay || 35) * 1000);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-ot3-sleep-quiz]').forEach(initQuiz);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
